import { useState, useRef } from 'react';
import styles from '../../styles/style.module.scss';
import { t } from '@web-solutions/module-localization';
import { useRemoteConfig } from 'core/hooks/use-remote-config';

import getLocale from 'src/localization/get-locale';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { ArrowTopIcon } from 'src/onboarding/assets/icons/ArrowTopIcon';
import { ArrowBottomIcon } from 'src/onboarding/assets/icons/ArrowBottomIcon';

export const QuestionsComponent = () => {
  const { questions } = useRemoteConfig();
  const locale = getLocale();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.questionsContainer}>
      <Typography variant='h1-bold'>{t('onboarding.voeryPersonalPlan.questions.title')}</Typography>
      <div className={styles.questions}>
        {questions.map(({ question, answer }, index) => (
          <div key={index} className={styles.questionItem}>
            <div className={styles.reviewHeader} onClick={() => toggleQuestion(index)}>
              <Typography variant='body-semibold'>{question[locale]}</Typography>
              <span className={styles.arrowIcon}>
                {openIndex === index ? <ArrowTopIcon /> : <ArrowBottomIcon />}
              </span>
            </div>

            {openIndex === index && (
              <div className={styles.answer}>
                <Typography variant='body-semibold'>{answer[locale]}</Typography>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
